import { render } from "./swiper.vue?vue&type=template&id=1f2cae73&scoped=true"
import script from "./swiper.vue?vue&type=script&lang=js"
export * from "./swiper.vue?vue&type=script&lang=js"

import "./swiper.vue?vue&type=style&index=0&id=1f2cae73&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f2cae73"]])

export default __exports__